export default __webpack_public_path__ + "static/media/logo3.31b9591d.jpg";